export const useCampuses = (companyId: MaybeRefOrGetter<number | undefined>) => {
    const { campuses, company } = useCompany();
    const isMe = computed(() => company.value?.id === toValue(companyId));
    const { state, isLoading, execute } = useAsyncState(
        () =>
            isMe.value ? Promise.resolve(undefined) : api.getCampuses({ params: { companyId: toValue(companyId)! } }),
        undefined,
    );
    watch(
        () => toValue(companyId),
        () => {
            if (!isMe.value) {
                execute();
            }
        },
    );

    const merged = computed(() => state.value?.data ?? (isMe.value ? campuses.value : undefined));

    return {
        campuses: merged,
        isLoadingCampuses: isLoading,
        refresh: execute,
    };
};
